module.exports = __webpack_public_path__ + "static/media/fds-image.12294025.jpg";